import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

interface TextFieldProps {
  label?: string
  icon?: React.ReactNode
  text?: string | React.ReactElement
  className?: string
  fieldClassName?: string
  placeholder?: string
}

export const TextField = ({
  label,
  icon,
  placeholder,
  text,
  className,
  fieldClassName,
}: TextFieldProps) => {
  return (
    <div className={clsx(s.container, className)}>
      {label && <div className={s.label}>{label}</div>}
      <div className={clsx(s.textContainer, fieldClassName)}>
        {icon && <div className={s.icon}>{icon}</div>}
        {text}
        {!text && <span>{placeholder}</span>}
      </div>
    </div>
  )
}
